
    import { Options, Vue } from 'vue-class-component';

    @Options<ApEditBlock>({
        props: {
            onSave: Function,
        },
    })
    export default class ApEditBlock extends Vue {
        private readonly onSave!: () => boolean;
        public editing: boolean = false;

        public onEditChange(state: boolean) {
            state = state === true;
            if (state === this.editing) return;

            this.$emit('editing', state);
            this.editing = state;
        }
        public async onSaveInner() {
            const saved = await this.onSave();
            if (saved) {
                this.onEditChange(false);
            }
        }
    }
